import { posAppId } from "../config/envConfig";
import { APP_ID_KEY, DATA_REFERENCE } from "./Constants";

const Util = {
  getUserAgentData(data) {
    let { source, name } = data;
    source = source || "kiosk";
    name = name || "Sign Up";
    let ref = "Kiosk App";

    const referenceData = JSON.parse(localStorage.getItem(DATA_REFERENCE));

    let channel =
      referenceData && referenceData[APP_ID_KEY]
        ? referenceData[APP_ID_KEY]
        : posAppId;

    const qParams = `?source=${source}&name=${name}&channel=${channel}&ref=${ref}`;
    return qParams;
  },
};
export default Util;
